import React from 'react';
import {
  WorkforceGroupForm,
  WorkforceGroupFormProps,
  type UpdateWorkforceGroupInputDataType,
} from '@scheduling/components';
import { WorkforceGroupFormConsecutiveHoursTab } from './workforce-group-form-consecutive-hours-tab';
import { WorkforceGroupFormUtilizationRulesTab } from './workforce-group-form-utilization-rules-tab';

export function WorkforceGroupDrawerBaseForm({
  onUpdateInputData,
  inputData,
}: {
  onUpdateInputData: WorkforceGroupFormProps['onUpdateInputData'];
  inputData: Partial<UpdateWorkforceGroupInputDataType>;
}) {
  return (
    <WorkforceGroupForm
      onUpdateInputData={onUpdateInputData}
      inputData={inputData}
      showBanner
      bannerContent="These are considered the default settings for this Group, but you can also customize at the Location level."
      extraTabs={[
        {
          key: 'consecutiveHours',
          label: 'Consecutive Hours',
          children: (
            <WorkforceGroupFormConsecutiveHoursTab
              onUpdateInputData={onUpdateInputData}
              consecutiveHoursLimit={inputData.consecutiveHoursLimit}
              consecutiveHoursBridgeTolerance={
                inputData.consecutiveHoursBridgeTolerance
              }
              consecutiveHoursResetPeriod={
                inputData.consecutiveHoursResetPeriod
              }
            />
          ),
        },
        {
          key: 'weeklyUtilization',
          label: 'Weekly Utilization',
          children: (
            <WorkforceGroupFormUtilizationRulesTab
              onUpdateInputData={onUpdateInputData}
              weeklyUtilization={inputData.weeklyUtilization}
              utilizationRule={inputData.utilizationRule}
            />
          ),
        },
      ]}
    />
  );
}
